// Display labels for the treatment choices stored on the patient, copied from
// the dashboard creation flow: case types and approaches (treatmentDetails.ts)
// and MANUFACTURERS (utils/constants.ts). Keys are the Monday values.
// Candidate to move into @odo/shared-ui so the two apps cannot drift.

const CASE_TYPE_LABELS: Readonly<Record<string, string>> = {
    Pediatrics: 'Pediatric',
    Airway: 'Airway',
    'Traditional Ortho': 'Traditional Ortho',
    TMD: 'TMD'
};

const APPROACH_LABELS: Readonly<Record<string, string>> = {
    'Pediatrics 1': 'Phase 0 (primary dentition only)',
    'Pediatrics 2': 'Phase 1 (early to mixed dentition)',
    'Airway 1': 'Airway-Focused Level 1 (Mild)',
    'Airway 2': 'Airway-Focused Level 2 (Moderate)',
    'Airway 3': 'Airway-Focused Level 3 (Significant)',
    Traditional: 'Traditional ortho',
    'TMD 1': 'TMD Level 1 (Mild)',
    'TMD 2': 'TMD Level 2 (Moderate)',
    'TMD 3': 'TMD Level 3 (Significant)'
};

const MANUFACTURER_LABELS: Readonly<Record<string, string>> = {
    'Invisalign Aligners': 'Invisalign',
    'Spark Aligners': 'Spark Aligners'
};

// Unknown values (e.g. V2 approaches) are shown as recorded rather than hidden.
function labelFor(
    labels: Readonly<Record<string, string>>,
    key: string | null | undefined
): string | null {
    if (!key) return null;
    return labels[key] ?? key;
}

export function caseTypeLabel(mondayKey: string | null | undefined): string | null {
    return labelFor(CASE_TYPE_LABELS, mondayKey);
}

export function approachLabel(mondayKey: string | null | undefined): string | null {
    return labelFor(APPROACH_LABELS, mondayKey);
}

export function manufacturerLabel(id: string | null | undefined): string | null {
    return labelFor(MANUFACTURER_LABELS, id);
}
